<template>
  <div class="page-container flex-container">
    <ModalBox :visible="showModal" :infoTitle="infoTitle" :infoMessage="infoMessage" @close="showModal = false" />
    <!-- <CustomAnimatedLogo></CustomAnimatedLogo> -->
    
    <CustomAnimatedLogo v-if="isInProgress"></CustomAnimatedLogo>
    <div v-if="!isInProgress" class="container">
      <br>
      <h5 class="flex-container">Customer Presale Report Simulator</h5>
      <div class="info-disclaimer">
        <p>NOTE: This simulator is currently running in <span class="important-context">demo mode</span> only. All result data are for display purposes only, it may contain incorrect, inaccurate or misrepresented values.</p>
      </div>
      <div v-if="!showOutput" class="input-section">

        <div v-if="showSection=='manualInput'">
          <button type="button" @click="showSection = 'imageUpload'">Upload One Quarter's Power Bill Instead</button>
          <br>
        <form @submit.prevent="handleSubmit">


          <div class="customer-row twin-fields">
          <div>
          <label for="locationAddress">Location Address</label>
          <input type="text" v-model="form.location_address" required />
          </div>
          <div>
          <label for="customerName">Customer Name</label>
          <input type="text" v-model="form.customer_name" required />
          </div>
          </div>
          <div class="tariff-row twin-fields">
          <div>
          <label for="gridProviderName">Grid Provider Name</label>
          <input type="text" v-model="form.grid_provider_name" required />
          </div>
          <div>
          <label for="tariffType">Tariff Type</label>
          <select v-model="form.tariff_type" required>
            <option value=0>Flat</option>
            <option value=1 disabled>Time of Use (TOU)</option>
          </select>
          </div>
          </div>
          <div class="price-row twin-fields">
            <div>
              <label for="buyPrice">Buy Price ($AUD/kWh)</label>
              <input type="number" v-model="form.buy_price" required />
            </div>
            <div>
              <label for="sellPrice">Sell Price ($AUD/kWh)</label>
              <input type="number" v-model="form.sell_price" required />
            </div>
          </div>
          <div class="bill-row twin-fields">
          <div>
          <label for="powerBillAmount">One Quarter's Power Bill Amount ($AUD)</label>
          <input type="number" v-model="form.power_bill_amount" required />
          </div>
          <div>
            <label for="billDate">Bill Date</label>
            <input type="text" v-model="form.power_bill_date" required />
          </div></div>

           <!-- Manual input only -->
          <label for="totalEquipmentCost">Total Equipment Cost ($AUD)</label>
          <input type="number" v-model="form.solar_capacity" required />

          <div class="device-row twin-fields">
          <div>
          <label for="deviceModel">Device Model</label>
          <input type="text" v-model="form.device_model" required />
          </div>
          <div>
          <label for="numberOfDevices">Number of Devices</label>
          <input type="number" v-model="form.number_of_devices" required />
          </div></div>

          <div class="capacity-row twin-fields">
          <div>
          <label for="solarCapacity">Solar Capacity (kW)</label>
          <input type="number" v-model="form.solar_capacity" required />
          </div>
          <div>
          <label for="maxInverterCapacity">Max Inverter Capacity (kW)</label>
          <input type="number" v-model="form.max_inverter_capacity" required />
          </div></div>

          <button type="submit">Submit</button>
  
        </form>
      </div></div>
      <transition name="fade">
        <div v-if="showOutput" class="output-section">
          <div class="output-header flex-container">
            <h2>Simulation Output Report</h2>
          </div>

          <h4>Annual Savings</h4>
          <div class="savings-info">
            <StyledInfoBox
      valueWithUnit="$4,186"
      titleText="Savings p.a."
      secondDataValue="Over 75%"
      descText="Power Bill Reduction"></StyledInfoBox>
      
    <StyledInfoBox
    valueWithUnit="8.3t"
      titleText="Savings p.a."
      secondDataValue="Over 90%"
      descText="CO2E Reduction"></StyledInfoBox>
      <StyledInfoBox
      valueWithUnit="2.6 yr"
      titleText="Payback"
      secondDataValue="100%"
      descText="IRR over years">
    </StyledInfoBox>
</div>
<div class="comparison-data">
  <h5>Before / After Comparison</h5>
  <table class="custom-table">
    <thead>
        <tr>
          <th>Measurement</th>
          <th>Before</th>
          <th>After</th>
          <th>Difference (%)</th>
        </tr>
      </thead>
    <tbody>
        <tr v-for="(item, index) in beforeAfterComparisonData" :key="index">
          <td>{{ item.label }}</td>
          <td>
            <StyledInfoWithIcon
      :valueWithUnit="item.before.toLocaleString()"
      bgColor="rgb(255, 102, 102)"></StyledInfoWithIcon>
  </td>
  <td>
            <StyledInfoWithIcon
      :valueWithUnit="item.after.toLocaleString()"
      bgColor="rgb(50, 205, 50)"></StyledInfoWithIcon>
  </td>
      <td>
      <StyledInfoWithIcon
      :valueWithUnit="item.difference"
      iconName="caret-down"
      bgColor="rgb(255, 255, 255)"
            ></StyledInfoWithIcon>
       </td>
        </tr>      
    </tbody>
  </table>
  <!-- Chart -->
  <!-- <VueApexCharts v-if="series.length" type="column" :options="chartOptions" :series="series"></VueApexCharts> -->
</div>
          <div class="charts">
            <h5>One Year Grid Demand</h5>
            <canvas id="gridDemandChart"></canvas>
            <h5>Intraday Grid Power Demand</h5>
            <canvas id="intradayGridChart"></canvas>
            <h5>One Year Solar Power Generation</h5>
            <canvas id="solarGenerationChart"></canvas>
            <h5>Intraday Solar Generation</h5>
            <canvas id="intradaySolarChart"></canvas>
            <h5>Estimated 12 Month Cost Saving</h5>
            <table>
              <thead>
                <tr>
                  <th>Battery Capacity (kWh)</th>
                  <th>Additional Solar (kW)</th>
                  <!-- <th>Cost ($AUD)</th> -->
                  <th>Saving ($AUD)</th>
                  <th>Saving (%)</th>
                  <th>Average Rate ($AUD/kWh)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in costSavingData" :key="row.battery">
                  <td>{{ row.battery }}</td>
                  <td>{{ row.additional }}</td>
                  <!-- <td>{{ row.cost }}</td> -->
                  <td>{{ row.saving }}</td>
                  <td>{{ row.percent }}</td>
                  <td>{{ row.rate }}</td>
                </tr>
              </tbody>
            </table>
            <h5>Return on Investment (ROI) Summary</h5>
            <table>
              <thead>
                <tr>
                  <th>Equipment Cost ($AUD)</th>
                  <th>ROI Percentage (%)</th>
                  <th>ROI Payback Period (Years)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="roi in roiData" :key="roi.equipmentCost">
                  <td>{{ roi.equipmentCost }}</td>
                  <td>{{ roi.roiPercentage }}</td>
                  <td>{{ roi.roiDuration }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="info-disclaimer">
        <p>NOTE: <span class="important-context">T&Cs apply.</span> Please refer to the full product disclosure statement for details. Renox Technology reserves the right to make changes without prior notice.</p>
      </div>
      <br>
        <br>
        <br>
        <br>
        <br>
        </div>

      </transition>

      <div v-if="showSection=='imageUpload'" class="upload-section">
        <button type="button" @click="showSection = 'manualInput'">Show Manual Input Instead</button>
        <br>
        <div>
    <h2>Take Photo or Upload Bill Photo</h2>
    <!-- File input to upload an image -->
    <input type="file" @change="onFileChange" accept="image/*" capture="camera" ref="fileInput"/>
    <!-- Image Preview (optional) -->
    <div class="flex-container" v-if="img64">
      <h5>Image Preview</h5>
      <img :src="img64" id="preview-image" alt="Uploaded Image" />
      <h5>AI Processing Result: {{ resultResponseText }}</h5>
    </div>
    <button @click="processUpload">Submit</button>

    
  </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue';
import { apiRequest } from '@/services/apiService';
import { Chart } from 'chart.js';
import ModalBox from '@/components/cards/ModalBox.vue';
import CustomAnimatedLogo from '../cards/CustomAnimatedLogo.vue';
import StyledInfoBox from '../cards/StyledInfoBox.vue';
import VueApexCharts from 'vue3-apexcharts';
import StyledInfoWithIcon from '../cards/StyledInfoWithIcon.vue';


// Function to convert file to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data URL prefix
    reader.onerror = (error) => reject(error);
  });
};

export default {
  name: 'SimulatorPage',
  components: {
    ModalBox,
    CustomAnimatedLogo,
    StyledInfoBox,
    VueApexCharts,
    StyledInfoWithIcon,
  },
  computed: {

  },
  setup() {
    const beforeAfterComparisonData = ref([
        { label: 'ANNUAL SPEND ($AUD)', before: 2728, after: -3061, difference: "175.00%" },
        { label: 'ANNUAL CO2E (Tonnes)', before: 6.04, after: -2.8, difference: "146.67%" },
        { label: 'ANNUAL ENERGY (kWh)', before: 8254, after: -3783, difference: "145.00%" },
      ]);
    const subDataUrl = ref('/api/v1.1/data');  
    let resultResponseText = ref('');
    let isInProgress = ref(false);
    const form = ref({
      //// Image to text or manual input fields
      location_address: '',
      customer_name: '',
      grid_provider_name: '',
      tariff_type: 0,
      buy_price: 0,
      sell_price: 0,
      power_bill_amount: 0,
      power_bill_date: '',
      //// Manual input only
      total_equipment_cost: 0,
      device_model: '',
      number_of_devices: 1,
      solar_capacity: 0,
      max_inverter_capacity: 0,
    });
    const showSection= ref('manualInput');
    // const showSection= ref('imageUpload');
    const showOutput = ref(false);
    const uploadMode = ref(false);
    const costSavingData = ref([
      { battery: 5, additional: 0, saving: '$2.0K', percent: '10%', rate: '0.35' },
      { battery: 10, additional: 10, saving: '$5.0K', percent: '25%', rate: '0.25' },
      { battery: 15, additional: 15, saving: '$7.0K', percent: '35%', rate: '0.20' },
      { battery: 20, additional: 25, saving: '$10.0K', percent: '50%', rate: '0.15' },
      { battery: 25, additional: 35, saving: '$13.0K', percent: '65%', rate: '0.10' },
      { battery: 30, additional: 45, saving: '$15.0K', percent: '75%', rate: '0.08' },
      { battery: 35, additional: 55, saving: '$17.0K', percent: '85%', rate: '0.05' },
      { battery: 40, additional: 65, saving: '$19.5K', percent: '90%', rate: '0.03' },
    ]);
    const roiData = ref([
      { equipmentCost: '$ Price', roiPercentage: 20, roiDuration: 5 },
      // Additional rows...
    ]);
    const showModal = ref(false);
    const infoTitle = ref('');
    const infoMessage = ref('');

    const handleSubmit = async () => {
      showOutput.value = false;
      await new Promise(resolve => setTimeout(resolve, 100)); // Simulate delay
      showOutput.value = true;
      await nextTick();
      renderCharts();
    };

    const toggleUpload = () => {
      uploadMode.value = true;
      showOutput.value = false;
    };

    const processUpload = async () => {
      // Handle image processing and data extraction here
      uploadMode.value = false;
      showOutput.value = true;
      showSection.value = 'manualInput';
      await nextTick();
      renderCharts();
    };

    const renderCharts = () => {
      const ctx1 = document.getElementById('gridDemandChart').getContext('2d');
      const ctx2 = document.getElementById('intradayGridChart').getContext('2d');
      const ctx3 = document.getElementById('solarGenerationChart').getContext('2d');
      const ctx4 = document.getElementById('intradaySolarChart').getContext('2d');

     // Function to generate daily demand data for a year
function generateYearlyDemandData() {
    const dailyDemand = [];
    const baseDemand = 10; // Average daily demand in kWh

    for (let day = 0; day < 365; day++) {
        // Generate slight variations around the base demand
        const dailyVariation = Math.random() * 20 - 10; // Random variation between -10 and 10
        const dailyValue = Math.max(0, baseDemand + dailyVariation); // Ensure no negative values
        dailyDemand.push(dailyValue);
    }

    return dailyDemand;
}

const yearlyDemandData = generateYearlyDemandData();

// Create month labels for the x-axis, displaying each month once
const monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Create an array to hold the x-axis labels
const monthLabelsDisplay = [];

// Fill in the labels for the x-axis
for (let day = 0; day < 365; day++) {
    if (day === 0 || day === 30 || day === 59 || day === 89 || day === 119 || day === 150 || 
        day === 181 || day === 212 || day === 243 || day === 273 || day === 304 || day === 334) {
        monthLabelsDisplay[day] = monthLabels[Math.floor(day / 30)];
    } else {
        monthLabelsDisplay[day] = '';
    }
}

// Create the chart
new Chart(ctx1, {
    type: 'line',
    data: {
        labels: monthLabelsDisplay,
        datasets: [{
            label: 'Grid Demand (kWh)',
            data: yearlyDemandData,
            borderColor: 'rgba(15, 191, 238, 0.7)', // Light blue with % opacity
            fill: false,
        }]
    },
    options: {
        responsive: true,
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Months'
                }
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Energy (kWh)'
                }
            }
        }
    }
});

      new Chart(ctx2, {
        type: 'line',
        data: {
          labels: [
            '00:00', '00:30', '01:00', '01:30', '02:00', '02:30',
            '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
            '06:00', '06:30', '07:00', '07:30', '08:00', '08:30',
            '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
            '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
            '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
            '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
            '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
        ],
          datasets: [{
            label: 'Intraday Grid Power Demand (kWh)',
            data: [
                100, 105, 102, 103, 101, 100,  // Nighttime demand
                98, 99, 105, 110, 112, 115,    // Morning increase
                120, 123, 126, 128, 130, 135,  // Midday to afternoon
                140, 138, 135, 133, 132, 130,  // Early evening
                128, 125, 123, 121, 120, 118,  // Evening decline
                115, 112, 110, 108, 107, 105,  // Late night decrease
                103, 101, 100, 99, 98, 97      // Final decrease towards midnight
            ],
            backgroundColor: 'rgba(173, 216, 230, 0.7)', // Light blue with % opacity
            borderColor: 'rgba(173, 216, 230, 1)', // Light blue with full opacity
            fill: true,
          }]
        },
      });

      new Chart(ctx3, {
        type: 'line',
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [{
            label: 'Solar Power Generation (kWh)',
            data: [
        800,  // Jan
        750,  // Feb
        600,  // Mar
        450,  // Apr
        300,  // May
        150,  // Jun
        100,  // Jul
        150,  // Aug
        300,  // Sep
        500,  // Oct
        700,  // Nov
        900   // Dec
      ],
      backgroundColor: 'rgba(0, 255, 0, 0.2)', // Green with % opaci
            borderColor: 'green',
            fill: true,

          }]
        },
      });

      new Chart(ctx4, {
        type: 'line',
        data: {
          labels: [ '06:00', '06:30', '07:00', '07:30', '08:00', '08:30',
            '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
            '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
            '15:00', '15:30', '16:00', '16:30', '17:00', '17:30'],
          datasets: [{
            label: 'Intraday Solar Generation (kWh)',
            data: [3, 4, 7, 8, 9, 9, // Increasing values till 2 PM
                10, 11, 11, 11.5, 11, 10, // Gradually decrease after 2 PM
                10, 11, 9, 9, 8, 6, 6, // Continue decreasing
                4, 2, 2, 1, 0 // Final decrease],
                ],
            backgroundColor: 'rgba(0, 255, 0, 0.2)', // Green with % opacity
            borderColor: 'rgba(0, 255, 0, 1)', // green with full opacity
            fill: true,
          }]
        },
      });
    };

    // Reactive state for the Base64 image string
    const img64 = ref(null);

    const onFileChange = async (event) => {
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          img64.value = reader.result; // Set the Base64 string when reading is done
          calculateImageSize(img64.value); // Calculate image size
          if (img64.value) {
            // getOpenaiResult();
          }
        };
        reader.readAsDataURL(file); // Convert the file to Base64
      }
    };

    // const onFileChange = async (event) => {
    //   const file = event.target.files[0];
    //   if (file) {
    //     try {
    //       const base64String = await fileToBase64(file);
    //       img64.value = base64String;
    //       if (img64.value) {
    //         await getOpenaiResult();
    //       }
    //     } catch (error) {
    //       console.error('Error converting file to base64:', error);
    //     }
    //   }
    // };

    function calculateImageSize(base64String) {
      // Get the size of the Base64 string (excluding the "data:image/jpeg;base64," part)
      const base64StringWithoutPrefix = base64String.split(',')[1];  // Split to remove metadata
      const sizeInBytes = (base64StringWithoutPrefix.length * 3) / 4 - (base64StringWithoutPrefix.endsWith('==') ? 2 : base64StringWithoutPrefix.endsWith('=') ? 1 : 0);
      // Convert bytes to MB
      const sizeInMB = sizeInBytes / (1024 * 1024);  // 1 MB = 1024 * 1024 bytes

      let imageSize = 0;

      imageSize = {
        bytes: sizeInBytes,
        mb: sizeInMB.toFixed(2)  // Fix to two decimal places for better readability
      };

      console.log(`Base64 Image Size: ${imageSize.bytes} bytes`);
      console.log(`Base64 Image Size: ${imageSize.mb} MB`);

      // Also log the sizes in the console
      console.log(`Size in Bytes: ${imageSize.bytes} bytes`);
      console.log(`Size in MB: ${imageSize.mb} MB`);
    };

    // // Handle image processing
    // const processUpload = async () => {
    //   // Handle image processing and data extraction here
    //   console.log('Processing image...', img64.value);
      
    //   // Example processing logic (you can replace this with actual logic)
    //   if (img64.value) {
    //     uploadMode.value = false;
    //     showOutput.value = true;
    //     showSection.value = 'manualInput';

    //     // Wait for the DOM to update before rendering charts
    //     await nextTick();
    //     renderCharts();
    //   } else {
    //     console.error('No image uploaded.');
    //   }
    // };

    // Asynchronous function to fetch data
    const getOpenaiResult = async () => {
      try {
        isInProgress.value = true;
        // const bodyData = {
        // "model": "gpt-4o-mini",
        // "messages": [
        //   {
        //     "role": "user",
        //     "content": [
        //       {
        //         "type": "text",
        //         "text": "What’s in this image?"
        //       },
        //       // {
        //       //   "type": "image_url",
        //       //   "image_url": {
        //       //     "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Gfp-wisconsin-madison-the-nature-boardwalk.jpg/2560px-Gfp-wisconsin-madison-the-nature-boardwalk.jpg"
        //       //   }
        //       // }
        //       {
        //   "type": "image_url",
        //   "image_url": {
        //     "url": "data:image/jpeg;base64," + img64.value
        //   },
        // },
        //     ]
        //   }
        // ],
        // "max_tokens": 300
        // };

        const bodyData = {
          // model: "gpt-4-vision-preview", // Correct model name
          model: "gpt-4o-mini", // Correct model name
          messages: [
            {
              role: "user",
              content: [
              {
                  type: "text",
                  text: "Check the image and provide values for these variables, if value is not available, put type aware default value: Empty value for strings, 0 for ints, 0.0 for floats. Return it in machine parsable way, do not include anything else: \ncustomer_name (type: String)\nlocation_address (type: String)\ngrid_provider_name (type: String)\ntariff_type (type: int, [0 – flat, 1 – ToU])\nbuy_price (type: float, unit: AUD, alternate_names: [import_price])\nsell_price (type: float, unit: AUD, alternate_names: [export_price, feed-in_price])\npower_bill_amount (type: float, unit: AUD)\npower_bill_year (type: String)\npower_bill_month (type: String)\n"
                },

                {
                  type: "image_url",
                  image_url: {
                    // url: `data:image/jpeg;base64,${img64.value}`
                    url: img64.value
                  }
                }
              ]
            }
          ],
          max_tokens: 300 // Add max_tokens parameter
        };

        const url = `${subDataUrl.value}/openai/v1/chat/completions/get`;
        const response = await apiRequest('post', url, bodyData, {
          // headers: {
          //   'Content-Type': 'application/json'
          // }
        });
        isInProgress.value = false;
        // if (response.errorCode === 0 && response.data) {
          if (response && response.choices && response.choices.length > 0) {
            let contentValue = response?.choices?.[0]?.message?.content;
            console.log("This is the Openai response:", response);
            console.log("This is the Openai contentValue in the response: " + contentValue);
            resultResponseText.value = contentValue;
        }
      } catch (error) {
        console.error('Error fetching Openai result data:', error);
      } finally {
        // loading.value = false;
      }
    };

    return {
      isInProgress,
      subDataUrl,
      handleSubmit,
      toggleUpload,
      renderCharts,
      form,
      showOutput,
      showSection,
      uploadMode,
      costSavingData,
      roiData,
      showModal,
      infoTitle,
      infoMessage,
      beforeAfterComparisonData,
      img64,
      onFileChange,
      processUpload,
      resultResponseText,
    };
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
  max-width: 70vw;
  margin: auto;
}

.input-section,
.output-section,
.upload-section {
  background: var(--card-bg);
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  border: 1px solid var(--border-color);
}

input,
select,
button {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border-radius: 8px;
  border-width: 0.1px;
  background: var(--input-bg);
  color: var(--text-primary);
  border-color: var(--border-color);
}

input,
select,
button:focus {
  border-width: 0.06px;
  border-color: var(--custom-color1);
}


button {
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 8px;
}

button:hover {
  background-color: #45a049;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.twin-fields {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.twin-fields div {
  width: 48%; /* Adjust width as needed */
}

.charts {
  margin: 20px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid var(--border-color);
  padding: 8px;
  color: var(--text-primary);
}

th {
  background-color: rgba(247, 25, 5, 0.9);
  color: white;
}

.important-context {
  font-weight: bold;
}

th, td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-size: 0.8rem;
  }

  h1, h2, h3, h4, h5, h6, p, label, input, select, button, th, td {
      font-size: 70%; /* Set font size to % of the original size */
  }

  .savings-info{
    display: flex;
    justify-content: space-evenly;
  }

  .custom-table > th, td {
    border: none; /* Makes borders invisible */
    font-size: 1rem; /* Set font size to 2rem */;
  }

  .output-header {
    background-color: white;
    border-radius: 8px;
  }

  table.custom-table thead th {
    background-color: white; /* Use more specific selector */
    color: black; /* Ensure text is visible */
    border-radius: 8px;
    font-size: 1rem;
  }

  table.custom-table {
    border-collapse: separate; /* Change to 'separate' for border radius to work */
    border-spacing: 0; /* Remove default spacing between cells */
    border-radius: 10px; /* Adjust as needed for desired roundness */
    overflow: hidden; /* Prevent content from overflowing */
  }

  #preview-image {
    max-width: 80%;
    height: auto;
    margin: 10px;
  }


  @media (max-width: 750px) {

    th, td {
    border: 1px solid #ccc;
    padding: 3px;
    text-align: center;
    font-size: 0.3rem;
    }

    .savings-info{
      display: flex;
      flex-direction: column;
      justify-content: center; /* Centers items vertically */
      align-items: center; /* Centers items horizontally */
    }

    table.custom-table thead th {
    background-color: white; /* Use more specific selector */
    color: black; /* Ensure text is visible */
    border-radius: 8px;
    font-size: 0.4rem;
}
}
</style>
